<template>
    <vs-popup class="holamundo" :title="'Email to '+user.firstName+' '+user.lastName+ ' for '+emailTypeStrings[type]" :active.sync="displayContactModal">
       
        <div class="addCardFont font-semibold ml-5">Email</div>
        <vs-input 
            class="w-full p-5 pt-4"
            v-model="user.email" 
            :danger="errors.email.success"
            :danger-text="errors.email.msg"
            @input="validateEmail($event)" 
            
            maxLength="60" 
        />

        <div class="addCardFont font-semibold ml-5">Card Name</div>
        <vs-input 
            class="w-full p-5 pt-4"
             v-model="user.cardName" 
            :danger="errors.cardName.success"
            :danger-text="errors.cardName.msg"
            @input="validateSubject($event)" 
            :disabled="true"
        />
        <div class="addCardFont font-semibold ml-5">Issuer Name</div>
        <vs-input 
            class="w-full p-5 pt-4"
             v-model="user.issuerName" 
            :danger="errors.issuerName.success"
            :danger-text="errors.issuerName.msg"
            @input="validateSubject($event)" 
            :disabled="true"
        />
        <div v-show="errors.issuerName.success" class="text-danger validation-msg ml-5 pl-1 mt-1">{{ errors.issuerName.msg }}</div>
        <vs-row

        v-if="type === 'card_exists'"
        >
            <div class="addCardFont font-semibold ml-5">Existing Card Name</div>
            <vs-input 
                class="w-full p-5 pt-4"
                v-model="user.existingCardName" 
                :danger="errors.cardName.success"
                :danger-text="errors.cardName.msg"
                @input="validateSubject($event)" 
            />
            <div class="addCardFont font-semibold ml-5">Existing Issuer Name</div>
            <vs-input 
                class="w-full p-5 pt-4"
                v-model="user.existingIssuerName" 
                :danger="errors.issuerName.success"
                :danger-text="errors.issuerName.msg"
                @input="validateSubject($event)" 
            />
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" class="mt-5">
            <vs-button @click="sendMessage()">Send</vs-button>
        </vs-row>
    </vs-popup>
</template>

<script>
import { validateEmail, validateSubject, validateBody } from '@/views/admin/validation';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
    props: {
        displayContactModal: {
            type: Boolean
        },
        user: {
            type: [ Object, String ]
        },
        type:{
            type: String
        }
    },
    data(){
        return {
            subject: '',
            body: '', 

            validateEmail,
            validateSubject,
            validateBody,

            errors: {
                email: {
                    msg: '',
                    success: false
                },
                cardName: {
                    msg: '',
                    success: false
                },
                issuerName: {
                    msg: '',
                    success: false
                }
            },
            emailTypeStrings : {
                incomplete_info: 'Cards With Incomplete Info',
                wrong_info: 'Cards With Wrong Info',
                non_usa: 'Adding Non US Bank Card ',
                card_exists: 'Card Already in WF',
                
            },
            toast,
            genericErrorMessage
        }
    },
    methods: {
        validateInputField(){
            if(this.user.email.length<=0){
                this.errors.email = {
                    msg: 'email field cannot be empty',
                    success: true
                }
            }
            else{
                this.errors.email = {
                    msg: '',
                    success: false
                }
            }
            if(this.user.cardName.length<=0){
                this.errors.cardName = {
                    msg: 'Card Name field cannot be empty',
                    success: true
                }
            }
            else{
                this.errors.cardName = {
                    msg: '',
                    success: false
                }
            }
            if(this.user.issuerName.length<=0){
                this.errors.issuerName = {
                    msg: 'Issuer Name field cannot be empty',
                    success: true
                }
            }
            else{
                this.errors.issuerName = {
                    msg: '',
                    success: false
                }
            }
        },
        sendMessage(){
            this.validateInputField()
            let { email, cardName, issuerName } = this.errors;
            if(email.success || cardName.success || issuerName.success){
                return;
            }
            this.send();
        },
        send(){
            this.$vs.loading.close();
                this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
            const reqBody = {
                email: this.user.email,
                issuerName: this.user.issuerName,
                cardName: this.user.cardName,
                name: this.user.firstName+' '+this.user.lastName
            }
            if(this.type === 'card_exists'){
                reqBody['existingIssuerName'] = this.user.existingIssuerName ? this.user.existingIssuerName : ''
                reqBody['existingCardName'] = this.user.existingCardName ? this.user.existingCardName : ''
            }    
            this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.DeclineEmail,{
                ...reqBody
            },{
                    params:{
                        type:this.type
                    }
                }
            ).then(async res => {
                this.$vs.loading.close();
                if(res.data.success){
                    this.toast('Message sent successfully');
                    this.$emit('update:display-contact-modal', false)
                } else {
                    this.toast(this.genericErrorMessage());
                }
            }).catch(e => {
                this.$vs.loading.close();
                this.showMerge = false;
                if(e.response && e.response.status !== 401){
                    this.toast(this.genericErrorMessage());
                }
                // console.log("Error in mergeReuests: ",e);
            });
        }
    },
    watch: {
        displayContactModal(newval, oldval){
            this.subject = ''
            this.body = ''
            this.errors = {
                email: {
                    msg: '',
                    success: false
                },
                issuerName: {
                    msg: '',
                    success: false
                },
                cardName: {
                    msg: '',
                    success: false
                }
            }
        }
    }
}
</script>

<style scoped>
    .theme-dark .vs-con-textarea {
        background-color: #343434 !important;
        color: white !important;
    }
    .validation-msg {
        font-size: 12px;
    }
    .theme-dark .vs-con-input input {
        color: #CACACA !important;
    }
</style>